// Destination images - multiple images per destination for gallery
const DESTINATION_IMAGES = {
  // Japan
  'tokyo': [
    'https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?w=800',
    'https://images.unsplash.com/photo-1513407030348-c983a97b98d8?w=800',
    'https://images.unsplash.com/photo-1536098561742-ca998e48cbcc?w=800',
    'https://images.unsplash.com/photo-1542051841857-5f90071e7989?w=800',
  ],
  'kyoto': [
    'https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?w=800',
    'https://images.unsplash.com/photo-1545569341-9eb8b30979d9?w=800',
    'https://images.unsplash.com/photo-1528360983277-13d401cdc186?w=800',
    'https://images.unsplash.com/photo-1624253321171-1be53e12f5f4?w=800',
  ],
  'osaka': [
    'https://images.unsplash.com/photo-1590559899731-a382cb46c52f?w=800',
    'https://images.unsplash.com/photo-1583417319070-4a69db38a482?w=800',
    'https://images.unsplash.com/photo-1556679343-c1917e0bc575?w=800',
    'https://images.unsplash.com/photo-1589308078059-be1415eab4c3?w=800',
  ],
  // France
  'paris': [
    'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=800',
    'https://images.unsplash.com/photo-1499856871958-5b9627545d1a?w=800',
    'https://images.unsplash.com/photo-1509439581779-6298f75bf6e5?w=800',
    'https://images.unsplash.com/photo-1520939817895-060bdaf4fe1b?w=800',
  ],
  'nice': [
    'https://images.unsplash.com/photo-1491166617655-0723a0999cfc?w=800',
    'https://images.unsplash.com/photo-1534258936925-c58bed479fcb?w=800',
    'https://images.unsplash.com/photo-1528493366314-e317cd98dd52?w=800',
    'https://images.unsplash.com/photo-1517483000871-1dbf64a6e1c6?w=800',
  ],
  // Italy
  'rome': [
    'https://images.unsplash.com/photo-1552832230-c0197dd311b5?w=800',
    'https://images.unsplash.com/photo-1529260830199-42c24126f198?w=800',
    'https://images.unsplash.com/photo-1531572753322-ad063cecc140?w=800',
    'https://images.unsplash.com/photo-1515542622106-78bda8ba0e5b?w=800',
  ],
  'venice': [
    'https://images.unsplash.com/photo-1514890547357-a9ee288728e0?w=800',
    'https://images.unsplash.com/photo-1523906834658-6e24ef2386f9?w=800',
    'https://images.unsplash.com/photo-1534113414509-0eec2bfb493f?w=800',
    'https://images.unsplash.com/photo-1504019347908-b45f9b0b8dd5?w=800',
  ],
  'florence': [
    'https://images.unsplash.com/photo-1543429258-c5ca3cb5d458?w=800',
    'https://images.unsplash.com/photo-1534359265607-b9cad0dd7e36?w=800',
    'https://images.unsplash.com/photo-1541370976299-4d24ebbc9077?w=800',
    'https://images.unsplash.com/photo-1476362555312-ab9e108a0b7e?w=800',
  ],
  // Spain
  'barcelona': [
    'https://images.unsplash.com/photo-1583422409516-2895a77efded?w=800',
    'https://images.unsplash.com/photo-1539037116277-4db20889f2d4?w=800',
    'https://images.unsplash.com/photo-1562883676-8c7feb83f09b?w=800',
    'https://images.unsplash.com/photo-1523531294919-4bcd7c65e216?w=800',
  ],
  // Greece
  'santorini': [
    'https://images.unsplash.com/photo-1613395877344-13d4a8e0d49e?w=800',
    'https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=800',
    'https://images.unsplash.com/photo-1601581875039-e899893d520c?w=800',
    'https://images.unsplash.com/photo-1533105079780-92b9be482077?w=800',
  ],
  'athens': [
    'https://images.unsplash.com/photo-1555993539-1732b0258235?w=800',
    'https://images.unsplash.com/photo-1603565816030-6b389eeb23cb?w=800',
    'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800',
    'https://images.unsplash.com/photo-1608848461950-0fe51dfc41cb?w=800',
  ],
  // USA
  'new york': [
    'https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?w=800',
    'https://images.unsplash.com/photo-1534430480872-3498386e7856?w=800',
    'https://images.unsplash.com/photo-1522083165195-3424ed129620?w=800',
    'https://images.unsplash.com/photo-1485871981521-5b1fd3805eee?w=800',
  ],
  'los angeles': [
    'https://images.unsplash.com/photo-1534190760961-74e8c1c5c3da?w=800',
    'https://images.unsplash.com/photo-1515896769750-31548aa180ed?w=800',
    'https://images.unsplash.com/photo-1580655653885-65763b2597d0?w=800',
    'https://images.unsplash.com/photo-1506190503914-c7f8c0e9e0e2?w=800',
  ],
  'san francisco': [
    'https://images.unsplash.com/photo-1501594907352-04cda38ebc29?w=800',
    'https://images.unsplash.com/photo-1521747116042-5a810fda9664?w=800',
    'https://images.unsplash.com/photo-1506146332389-18140dc7b2fb?w=800',
    'https://images.unsplash.com/photo-1534050359320-02900022671e?w=800',
  ],
  // UK
  'london': [
    'https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=800',
    'https://images.unsplash.com/photo-1486299267070-83823f5448dd?w=800',
    'https://images.unsplash.com/photo-1533929736458-ca588d08c8be?w=800',
    'https://images.unsplash.com/photo-1526129318478-62ed807ebdf9?w=800',
  ],
  // Thailand
  'bangkok': [
    'https://images.unsplash.com/photo-1508009603885-50cf7c579365?w=800',
    'https://images.unsplash.com/photo-1563492065599-3520f775eeed?w=800',
    'https://images.unsplash.com/photo-1506665531195-3566af2b4dfa?w=800',
    'https://images.unsplash.com/photo-1583417319070-4a69db38a482?w=800',
  ],
  // Indonesia
  'bali': [
    'https://images.unsplash.com/photo-1537996194471-e657df975ab4?w=800',
    'https://images.unsplash.com/photo-1555400038-63f5ba517a47?w=800',
    'https://images.unsplash.com/photo-1573790387438-4da905039392?w=800',
    'https://images.unsplash.com/photo-1518548419970-58e3b4079ab2?w=800',
  ],
  // Australia
  'sydney': [
    'https://images.unsplash.com/photo-1506973035872-a4ec16b8e8d9?w=800',
    'https://images.unsplash.com/photo-1524293581917-878a6d017c71?w=800',
    'https://images.unsplash.com/photo-1523428096881-5bd79d043006?w=800',
    'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800',
  ],
  // UAE
  'dubai': [
    'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=800',
    'https://images.unsplash.com/photo-1518684079-3c830dcef090?w=800',
    'https://images.unsplash.com/photo-1546412414-e1885259563a?w=800',
    'https://images.unsplash.com/photo-1580674684081-7617fbf3d745?w=800',
  ],
  // Default fallback
  'default': [
    'https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=800',
    'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=800',
    'https://images.unsplash.com/photo-1530789253388-582c481c54b0?w=800',
    'https://images.unsplash.com/photo-1501785888041-af3ef285b470?w=800',
    'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=800',
  ]
};

export const getDestinationImages = (city) => {
  const cityLower = city?.toLowerCase() || '';
  return DESTINATION_IMAGES[cityLower] || DESTINATION_IMAGES['default'];
};

export default DESTINATION_IMAGES;
